/**
 * Get text content from XML element by tag name
 * @param {Document} xmlDoc - XML document
 * @param {string} tagName - Tag name to find
 * @returns {string}
 */
export const getXmlSection = (xmlDoc, tagName) => {
  const node = xmlDoc.getElementsByTagName(tagName)[0];
  return node ? node.textContent.trim() : '';
};

/**
 * Extract methods from XML document
 * @param {Document} xmlDoc - XML document
 * @returns {Array}
 */
export const extractMethods = (xmlDoc) => {
  return Array.from(xmlDoc.getElementsByTagName('Method')).map(m => ({
    name: m.getAttribute('Name'),
    declaration: m.getElementsByTagName('Declaration')[0]?.textContent.trim(),
    implementation: m.getElementsByTagName('Implementation')[0]?.textContent.trim(),
  }));
};

/**
 * Extract properties from XML document
 * @param {Document} xmlDoc - XML document
 * @returns {Array}
 */
export const extractProperties = (xmlDoc) => {
  return Array.from(xmlDoc.getElementsByTagName('Property')).map(p => ({
    name: p.getAttribute('Name'),
    declaration: p.getElementsByTagName('Declaration')[0]?.textContent.trim(),
    getDeclaration: p.getElementsByTagName('Get')[0]?.getElementsByTagName('Declaration')[0]?.textContent.trim(),
    getImplementation: p.getElementsByTagName('Get')[0]?.getElementsByTagName('Implementation')[0]?.textContent.trim(),
    setDeclaration: p.getElementsByTagName('Set')[0]?.getElementsByTagName('Declaration')[0]?.textContent.trim(),
    setImplementation: p.getElementsByTagName('Set')[0]?.getElementsByTagName('Implementation')[0]?.textContent.trim(),
  }));
};

/**
 * Extract events and translations from XML document
 * @param {Document} xmlDoc - XML document
 * @returns {Object} - { events, translations }
 */
export const extractEventsAndTranslations = (xmlDoc) => {
  const events = Array.from(xmlDoc.querySelectorAll('TcModuleClass DataTypes DataType EventId')).map(event => ({
    id: event.querySelector('Name').getAttribute('Id'),
    name: event.querySelector('Name').textContent,
    displayName: event.querySelector('DisplayName').textContent,
    severity: event.querySelector('Severity').textContent
  }));

  const translations = Array.from(xmlDoc.querySelectorAll('Translations > Text')).map(textNode => {
    const languages = {};
    textNode.querySelectorAll('Text').forEach(lang => {
      languages[lang.getAttribute('LcId')] = lang.textContent;
    });

    return {
      txtId: textNode.getAttribute('TxtId'),
      languages: languages
    };
  });

  return { events, translations };
};

/**
 * Decode base64 encoded string to UTF-8
 * @param {string} base64String - Base64 encoded string
 * @returns {string}
 */
export const decodeBase64 = (base64String) => {
  const bytes = Uint8Array.from(atob(base64String), c => c.charCodeAt(0));
  return new TextDecoder('utf-8', { ignoreBOM: false }).decode(bytes);
};
